export const queryKeys = {
  REGION_FEEDBACKS_VIEW: "region-feedbacks-view",
  REGION_ONE_FEEDBACK_VIEW: "region-one-feedback-view",
}